module.exports = __webpack_public_path__ + "0ba5d41b3ecdbe57351ca1f52b0a04e8.MP3";